import {makePatchAuthRequest} from 'main/factories/usecases/private/authorizations';
import {PatchAuthRequestParams} from 'domain/usecases';

export const patchAuthRequest = async (
	nuControle: string,
	params: PatchAuthRequestParams,
	signal?: AbortSignal,
) => {
	const response = await makePatchAuthRequest(nuControle).patch({...params, signal});
	return response;
};
